<template>
    <section class="acoes" id="acoes">
        
        <div class="container">

            <div class="row margin-b1">
                <div class="col-8 offset-2 col-md-10 offset-md-0">
                    <img src="images/acoes-titulo.png" style="max-height: 70px;" />
                </div>
            </div>

            <div class="row">
                
                <div class="col-10 offset-1 offset-md-0 col-md-3 acao" v-for="(acao, acaoIndex) in acoes" :key="acaoIndex" v-show="(!resumo) || (resumo & acaoIndex < 4)">
                    <router-link :to="{ name: 'acao', params: { slug: acao.Link } }">
                        <div class="thumb" :style="{ 'background-image' : 'url(' + $sdk.prefix_images + acao.Capa + ')' }"></div>
                        <span>{{ acao.Titulo }} | {{  new Date(acao.Data) | dateFormat('DD/MM/YYYY') }}</span>
                    </router-link>
                </div>

            </div>

            <div class="row" v-show="resumo">
                <div class="col-md-12">
                    <button @click="clic">Ver todas as ações</button>
                </div>
            </div>

        </div>
        
    </section>
</template>

<script>

export default {
    
    data() {
        return {
            acoes: [],
            errorMessage: null,
            s: null,
            resumo: true
        }
    },

    mounted: function(){

        this.carregar();

    },

    methods: {

        carregar: function(){

            var $this = this;

            $this.$sdk.get('acoes', function(ret){

                $this.acoes = ret;               


            })
        },

        clic: function(){
            this.resumo = (!this.resumo);
        }

    }

}
</script>